import axios from "axios";
import { FETCH_ALL_PRINCIPLE_API } from "../Constants/Apis";

export const getPrinciples = async () => {
  try {
    return axios.get(FETCH_ALL_PRINCIPLE_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createPrinciple = async (payload) => {
  try {
    return axios.post(FETCH_ALL_PRINCIPLE_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updatePrinciple = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_PRINCIPLE_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deletePrinciple = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_PRINCIPLE_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

